export enum Method {
  Get = 'get',
  Post = 'post'
}
